import type * as React from 'react';

function SvgPositiveEV(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg fill="none" height="1em" viewBox="0 0 24 24" width="1em" {...props}>
      <path
        d="M12 2C6.4863 2 2 6.4858 2 12C2 17.5142 6.4863 22 12 22C17.5137 22 22 17.5142 22 12C22 6.4858 17.5137 2 12 2ZM12 20C7.5889 20 4 16.4111 4 12C4 7.5889 7.5889 4 12 4C16.4111 4 20 7.5889 20 12C20 16.4111 16.4111 20 12 20Z"
        fill="currentColor"
      />
      <path
        d="M14.4521 13.728L12.7109 8.7466H7.38181V15.2534H11.8955V14.1372L8.6914 14.1328V12.522H11.4326V11.4331H8.7012V9.8535H11.8378L13.7051 15.2534H15.1943L17.4443 8.7466H16.1846L14.4521 13.728Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default SvgPositiveEV;
